import { checkEnumEq } from '@/general/src/other/checkEnumEq.js'
import { getConstKeys } from '@/general/src/other/getConstKeys.js'
import { z } from 'zod'
import type { InsuranceCustomerType as InsuranceCustomerTypePrisma } from '@/backend/src/services/other/prisma.js'
export const insuranceCustomerTypesMap = {
  personal: 'Физ. лицо',
  business: 'Юр. лицо',
} as const
export const insuranceCustomerTypes = getConstKeys(insuranceCustomerTypesMap)
export type InsuranceCustomerType = keyof typeof insuranceCustomerTypesMap
checkEnumEq<InsuranceCustomerType, InsuranceCustomerTypePrisma, true>()
export const zInsuranceCustomerType = z.enum(insuranceCustomerTypes)
export const insuranceCustomerTypesOptions = insuranceCustomerTypes.map((key) => ({
  value: key,
  label: insuranceCustomerTypesMap[key],
}))
export const getInsuranceCustomerTypeTitle = (insuranceCustomerType: keyof typeof insuranceCustomerTypesMap) => {
  return insuranceCustomerTypesMap[insuranceCustomerType]
}
